<template>
  <button :class="`adn-action-button adn-action-button-${state}`">
    <slot></slot>
  </button>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'

defineProps({
  state: {
    type: String as PropType<'default' | 'selected'>,
    default: 'default',
  },
})
</script>

<style lang="scss" scoped>
.adn-action-button {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-2);
  align-items: center;
  padding: var(--spacing-2) var(--spacing-3);
  color: var(--color-black);
  height: 3.7rem;
  font-weight: 400;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border: 1px solid var(--color-grey-light);
  border-radius: 10rem;
  cursor: pointer;

  &:hover {
    border: 1px solid var(--color-grey-dark);
  }

  &-selected {
    color: var(--color-white);
    background-color: var(--color-main-dark);
  }
}
</style>
